import { useEffect, useState } from 'react';
import Select from 'react-select';
import './ApiSelect.css';
import { useTranslation } from 'react-i18next';
import { categoryAPI } from '../../services/apiService';

function ApiSelect({ onSelect, className = '' }) {
    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await categoryAPI.getAll();
                const formattedOptions = Object.entries(data).map(([key, item]) => ({
                    value: item.id,
                    label: item.title,
                }));
                setOptions(formattedOptions);
            } catch (err) {
                console.error(err);
            }
        };
        fetchData();
    }, []);

    const handleChange = (selectedOption) => {
        setSelected(selectedOption);
        onSelect(selectedOption);
    };

    return (
        <div className={`api-select-container ${className}`}>
            <Select
                classNamePrefix="react-select"
                options={options}
                value={selected}
                onChange={handleChange}
                isClearable
                placeholder={t('categrotySelection')}
            />
        </div>
    );
}

export default ApiSelect;
